var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuyer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11H6V16H4V11ZM4.556 3.888C4.801 3.398 5.45 3 6.006 3H17.993C18.549 3 19.199 3.398 19.443 3.888L21 7H3L4.556 3.888ZM3 7H21V8H3V7ZM18 11H20V16H18V11ZM3 8C3.14 9.128 4.094 10 5.25 10C6.406 10 7.36 9.128 7.5 8H3ZM7.5 8C7.64 9.128 8.594 10 9.75 10C10.906 10 11.86 9.128 12 8H7.5ZM12 8C12.14 9.128 13.094 10 14.25 10C15.406 10 16.36 9.128 16.5 8H12ZM16.5 8C16.64 9.128 17.594 10 18.75 10C19.906 10 20.86 9.128 21 8H16.5ZM4 16H20V18.995C20.0013 19.5253 19.792 20.0343 19.4181 20.4103C19.0442 20.7863 18.5363 20.9984 18.006 21H5.994C5.73133 20.9996 5.47131 20.9474 5.22885 20.8464C4.98639 20.7453 4.76624 20.5975 4.58101 20.4112C4.39579 20.225 4.24912 20.004 4.14943 19.761C4.04973 19.518 3.99895 19.2577 4 18.995V16Z",
    fill: "#252728"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyer);
export default __webpack_public_path__ + "static/media/buyer.0cccbf033f049ee46798a30648ec7a76.svg";
export { ForwardRef as ReactComponent };